<script lang="ts">
  import Icon from './icon.svelte';

  /**
   * The compact dark CTA strip that breaks up a long page.
   *
   * Three on the Intelligence page, identical but for the copy, the section
   * background and whether the button points at the platform or at the
   * contact form. `external` controls the `target="_blank"` pair: the two
   * platform banners open a new tab, the contact one navigates in place, and
   * that difference was easy to get wrong when the block was copied.
   */
  let {
    heading,
    lead,
    ctaText,
    href = 'https://platform.ainova.ch',
    external = true,
    bg = 'bg-surface'
  }: {
    heading: string;
    lead: string;
    ctaText: string;
    href?: string;
    external?: boolean;
    bg?: string;
  } = $props();
</script>

<div class="{bg} section-y-compact">
  <div class="mx-auto max-w-7xl px-6 lg:px-8">
    <div class="hero-brand rounded-xl px-8 py-8 lg:px-12">
      <div class="flex flex-col items-start gap-6 lg:flex-row lg:items-center lg:justify-between">
        <div>
          <h2 class="t-subhead-inverse">
            {heading}
          </h2>
          <p class="mt-1.5 text-base text-ink-inverse-muted">
            {lead}
          </p>
        </div>
        {#if external}
          <a
            {href}
            target="_blank"
            rel="noopener noreferrer"
            class="btn-hero-teal whitespace-nowrap"
          >
            {ctaText}
            <Icon name="arrow-right" class="ml-2" />
          </a>
        {:else}
          <a {href} class="btn-hero-teal whitespace-nowrap">
            {ctaText}
            <Icon name="arrow-right" class="ml-2" />
          </a>
        {/if}
      </div>
    </div>
  </div>
</div>
